module.exports = __webpack_public_path__ + "img/visa.1e56cc6.svg";